const CircleCheckWhite = ({ className }: { className: string }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M8 14C9.5913 14 11.1174 13.3679 12.2426 12.2426C13.3679 11.1174 14 9.5913 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.88258 13.3679 6.4087 14 8 14ZM10.6484 6.89844L7.64844 9.89844C7.42812 10.1187 7.07188 10.1187 6.85391 9.89844L5.35391 8.39844C5.13359 8.17812 5.13359 7.82188 5.35391 7.60391C5.57422 7.38594 5.93047 7.38359 6.14844 7.60391L7.25 8.70547L9.85156 6.10156C10.0719 5.88125 10.4281 5.88125 10.6461 6.10156C10.8641 6.32188 10.8664 6.67812 10.6461 6.89609L10.6484 6.89844Z"
      fill="white"
    />
  </svg>
);

export default CircleCheckWhite;
